import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";

export interface ISalesOrderLineDesignInfo {
    orderID: number;
    orderItemID: number;
    mItemID: number;
    designID: number;
    inventoryLotId: string;
    dataAreaId: string;
}

const getSalesOrderLineDesigns = async (
    orderID: number,
): Promise<ISalesOrderLineDesignInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<ISalesOrderLineDesignInfo[]>(
        `/SalesOrderLine/GetSalesOrderLineDesignsCS/${orderID}`,
    );
    return response.data;
};

export const useGetSalesOrderLineDesigns = (orderID: number) => {
    return useQuery<ISalesOrderLineDesignInfo[]>({
        queryKey: ["GetSalesOrderLineDesignsCS", orderID],
        queryFn: () => getSalesOrderLineDesigns(orderID),
        enabled: orderID > 0,
        refetchOnWindowFocus: false,
        retry: false,
    });
};
